import React from 'react';
import { usePage } from '@inertiajs/react';
import { AppSidebar } from './app-sidebar';
import {
  SidebarInset,
  SidebarTrigger
} from './ui/sidebar';
import { getGroupedNavigation, type Role } from '@/config/navigation';


interface DashboardLayoutProps {
  children: React.ReactNode;
}

interface AuthUser {
  id: number;
  name?: string;
  username?: string;
  email: string;
  role: 'user' | 'admin' | 'manager';
  role_level?: number;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const { auth } = usePage().props as any;
  const user = auth?.user as AuthUser | undefined;

  // Get user's role level (fallback to 0 if not set)
  const userLevel = user?.role_level ?? (user?.role === 'admin' ? 2 : user?.role === 'manager' ? 1 : 0);
  const userRole = (user?.role || 'user') as Role;

  // Get grouped navigation from config
  const groupedNav = getGroupedNavigation(userRole, userLevel);

  if (!user) {
    return (
      <div className="flex h-screen">
        <div className="flex-1 flex items-center justify-center">
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <AppSidebar 
        user={user}
        flatItems={groupedNav.flat}
        managerItems={groupedNav.manager}
        adminItems={groupedNav.admin}
      />
      <SidebarInset>
        <header className="flex h-12 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
    
        </header>
        <main className="p-2 md:p-4 ">
          {children}
        </main>
      </SidebarInset>
    </>
  );
};

export default DashboardLayout;
